// Global state management for the application
class GlobalState {
  constructor() {
    this.currentUser = {
      id: null,
      username: null,
      fullNameAr: null,
      fullNameEn: null,
      firstNameAr: null,
      firstNameEn: null,
      lastNameAr: null,
      lastNameEn: null,
      phone: null,
      avatar: null,
    };
    this.listeners = [];
  }

  // Set current user data
  setCurrentUser(userData) {
    this.currentUser = {
      id: userData.id || null,
      username: userData.username || null,
      fullNameAr: userData.full_name_ar || null,
      fullNameEn: userData.full_name_en || null,
      firstNameAr: userData.first_name_ar || null,
      firstNameEn: userData.first_name_en || null,
      lastNameAr: userData.last_name_ar || null,
      lastNameEn: userData.last_name_en || null,
      phone: userData.phone || null,
      avatar: userData.avatar || null,
    };

    // Notify all listeners
    this.notifyListeners();
  }

  // Get current user data
  getCurrentUser() {
    return { ...this.currentUser };
  }

  // Get current username
  getCurrentUsername() {
    return this.currentUser.username;
  }

  // Get current user ID
  getCurrentUserId() {
    return this.currentUser.id;
  }

  // Add listener for state changes
  addListener(listener) {
    this.listeners.push(listener);

    // Return unsubscribe function
    return () => {
      const index = this.listeners.indexOf(listener);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  // Notify all listeners
  notifyListeners() {
    this.listeners.forEach((listener) => {
      listener(this.currentUser);
    });
  }

  // Clear current user data (for logout)
  clearCurrentUser() {
    this.currentUser = {
      id: null,
      username: null,
      fullNameAr: null,
      fullNameEn: null,
      firstNameAr: null,
      firstNameEn: null,
      lastNameAr: null,
      lastNameEn: null,
      phone: null,
      avatar: null,
    };
    this.notifyListeners();
  }
}

// Create singleton instance
const globalState = new GlobalState();

export default globalState;
